import { ChangeEvent, memo } from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { DropDown } from '@qrios/frontend-library';

interface Props {
  monthsRange: string[];
  selectedMonth: string;
  handleMonthChange: (value: string | string[]) => void;
  handleBlur?: (e: ChangeEvent) => void;
}

const MonthSelector = ({ monthsRange, selectedMonth, handleMonthChange, handleBlur = () => {} }: Props) => {
  const theme = useTheme();

  return (
    <Box height={theme.customComponents.usageSummaryMonthSelector.height} pl={3}>
      <DropDown
        width={160}
        label="Select month"
        value={selectedMonth}
        options={monthsRange}
        name="month"
        handleChange={(e, value) => handleMonthChange(value as string)}
        handleBlur={handleBlur}
        disableClearable={true}
      />
    </Box>
  );
};

export default memo(MonthSelector);
